export default __webpack_public_path__ + "static/media/Create-documentation.0e2afd66.md";